// extracted by mini-css-extract-plugin
module.exports = {"hours":"style_hours__251OY","minutes":"style_minutes__3mDY6","hour":"style_hour__3lBM-","minute":"style_minute__1PLTF","selected":"style_selected__1haBE"};